import { unavailableOnWeb } from './unavailableOnWeb.web';
/**
 * Web stub for `PermissionsAndroid`, which react-native-web does not export.
 */
export const PermissionsAndroid = {
    PERMISSIONS: {
        CAMERA: 'android.permission.CAMERA',
    },
    check: unavailableOnWeb('PermissionsAndroid.check'),
    request: unavailableOnWeb('PermissionsAndroid.request'),
};
